import { NgModule } from '@angular/core';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { NOTES_SERVICE } from '@core/injection-tokens/notes.injection.token';
import { MojoAvatarModule } from 'mojo-avatar';

import { CandidatesConfig } from '@modules/candidates/candidates.abstract.config';
import { candidatesConfig } from '@modules/candidates/candidates.config';
import { FeedbackModule } from '@shared/feedback/feedback.module';
import { SharedModule } from '@shared/shared.module';
import { TimeDiffModule } from '@shared/time-diff/time-diff.module';
import { MojoEditorModule } from 'mojo-editor';
import { MojoIrpNotesModule } from 'mojo-irp-notes';

import { NotesItemComponent } from './item/notes-item.component';
import { NotesListComponent } from './notes-list/notes-list.component';
import { NotesOptionsComponent } from './options/notes-options.component';
import { NotesModalComponent } from '@modules/notes/components/modal/notes-modal.component';
import { FormModule } from '@shared/form/form.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotesTeamMembersModalComponent } from '@modules/notes/components/modal/team-members/notes-team-members-modal.component';
import { MojoAutocompleteModule } from 'mojo-autocomplete';

const components = [
  NotesItemComponent,
  NotesOptionsComponent,
  NotesListComponent,
  NotesModalComponent,
  NotesTeamMembersModalComponent,
];

@NgModule({
  imports: [
    SharedModule,
    FeedbackModule,
    MojoAvatarModule,
    TimeDiffModule,
    FormModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MojoAutocompleteModule,
    MojoIrpNotesModule.forRoot(NOTES_SERVICE),
    MojoEditorModule.forRoot(EDITOR_SERVICE),
  ],
  declarations: [...components],
  providers: [
    {
      provide: CandidatesConfig,
      useValue: candidatesConfig,
    },
  ],
  exports: [...components],
})
export class NotesComponentsModule {}
